import { IInformation } from 'src/features/getStartedUI/form/ts/interfaces';
import RegisterCompanyFormNew from './RegisterCompanyFormNew';

export type RegisterCompanyFormProps = {
  information: Pick<
    IInformation,
    'title' | 'title_form' | 'company_section_title' | 'create_company_user_title'
  >;
  handleOnSubmit: (data: any) => void;
  isLoading?: boolean;
};

const RegisterCompanyFormWrapper = (props: RegisterCompanyFormProps) => {
  return <RegisterCompanyFormNew {...props} />;
};

export default RegisterCompanyFormWrapper;
